import cx from 'classnames';
import Box, { BoxStyleProps } from '../../Box';
import Text from '../../Text';

import styles from './WidgetHeaderTimer.module.css';

interface WidgetHeaderTimerProps extends BoxStyleProps {
  className?: string;
  time?: string;
  description?: string;
}

export default function WidgetHeaderTimer({
  className,
  description,
  time,
  ...otherProps
}: WidgetHeaderTimerProps): JSX.Element {
  return (
    <Box className={cx(styles['base'], className)} {...otherProps}>
      <Text size="small">{description}</Text>
      <Text size="small" weight="700">
        {time}
      </Text>
    </Box>
  );
}
